module.exports = __webpack_public_path__ + "static/media/no_internet_connectivity.7b8249be.svg";